import { ReactNode } from "react";
import { useGraphileFiltersUrlQuery } from "components/Shared/FilterEditor/urlQuerySerializers";
import { BrandOrderingPlatformFilter } from "__generated__/gql/graphql";
import FilterBarWithSearch from "components/Shared/FilterEditor/FilterBar/FilterBarWithSearch";
import CustomersTable, { Props as TableProps } from "./Table";
import filterDefinitionsWithProducts from "./filterDefinitions";

type Props = TableProps & {
  headerRight?: ReactNode;
};

export default function CustomersTableView({
  filter: filterProp,
  headerRight,
  ...rest
}: Props) {
  const { filter, filters, isTableReady, handleFiltersChange } =
    useGraphileFiltersUrlQuery<BrandOrderingPlatformFilter>(
      filterDefinitionsWithProducts,
    );

  return (
    <>
      <FilterBarWithSearch
        key={String(isTableReady)}
        filterDefinitions={filterDefinitionsWithProducts}
        filters={filters}
        onFiltersChange={handleFiltersChange}
        headerRight={headerRight}
      />
      <CustomersTable {...rest} filter={filter} isReady={isTableReady} />
    </>
  );
}
